<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import learningApiUser from '@src/services/api/learning/user'
import DefineValidation from '@services/validation/DefineValidation'
import { useLearningAuthStore } from '@stores/auth'
import Modal from '@components/modal/Modal.vue'

const { updateTempAccessToken } = useLearningAuthStore()

const router = useRouter()

const { errors, meta, handleSubmit, handleReset, models } = new DefineValidation((modules) => {
  return {
    identifier: modules.string().required().min(4).max(16).label('ログインID')
  }
})

const sendButtonDisabled = computed(() => {
  return !(meta.value.valid && meta.value.dirty)
})

const showCompleteModal = ref(false)

const toMailAuth = () => {
  showCompleteModal.value = false
  router.push({
    name: 'ReminderInputAuth'
  })
}

const sendForm = handleSubmit(async (values) => {
  const body = {
    identifier: models.identifier.value
  }
  console.log('body', body)
  learningApiUser.sendReminder(body).then((res) => {
    console.log('editMailAddress res', res)
    updateTempAccessToken(res.data.access_token)
    showCompleteModal.value = true
  }).catch((err) => {
    console.error('editMailAddress err', err)
  })
})
</script>

<template>
  <section>
    <div class="container">
      <h2>パスワード再設定</h2>
      <p>ご登録のログインIDを⼊⼒し、再設定メールを送信ボタンを押してください。<br><br></p>
      <form @submit.prevent="sendForm">
        <div class="c-compBox">
          <div class="p-form-field">
            <label
              for="identifier"
              class="c-input-label"
            ><span class="c-form-required">必須</span>ログインID</label>
            <input
              id="identifier"
              v-model="models.identifier.value"
              type="text"
              class="c-input-text"
              placeholder=""
              autocomplete="off"
              maxlength="256"
            >
            <div class="c-validationError u-text-left">
              {{ errors.identifier }}
            </div>
          </div>
          <div class="authEmailSend__send">
            <button
              type="submit"
              class="c-button c-button--medium c-button--yellow"
            >
              再設定メールを送信
            </button>
            <RouterLink
              :to="{name:'Login'}"
              class="c-button c-button--medium c-button--border"
            >
              戻る
            </RouterLink>
          </div>
        </div>
      </form>
    </div>

    <Modal :show="showCompleteModal">
      <template #body>
        <div class="l-modal__body">
          <h2 class="l-modal__ttl">
            メールを送信しました。<br>メールにある認証コードを<br>次の画面で入力してください。
          </h2>
          <div class="l-modal__buttons">
            <button
              class="c-modalBtn c-modalBtn--single c-modalBtn--gray"
              type="button"
              @click="toMailAuth"
            >
              認証コード入力画面へ
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </section>
</template>

<style scoped lang="scss">
.container {
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }
}
.btnContainer {
  margin-top: 20px;
}
</style>
